import { trpc } from '@/data-loaders';
import { useDataLoadLastRun, useHandleError, useHandleSuccess } from '@/hooks';
import { useAwmsStore } from '@/store';
import { Button } from '@curtin-dxp/curtin-ui';
import { useEffect, useState } from 'react';
import RequirementsScroll from './RequirementsScroll';
import TroubleshootingScroll from './TroubleshootingScroll';
import ErdDiagram from './ErdDiagram';
export const DISABLED_IN_MINUTES = 15;

export const DataLoad = () => {
  const { data: dataLoadLastRun, isRefetching } = useDataLoadLastRun();
  const [disabledButton, setDisabledButton] = useState(true);
  const trpcUtils = trpc.useUtils();

  const activeYear = useAwmsStore((state) => state.activeYear);

  const sendToastStartDataLoadSuccess = useHandleSuccess({
    title: 'Start data load',
  });
  const handleError = useHandleError();
  const { mutate: startDataLoad } = trpc.startDataLoad.useMutation({
    onSuccess: async () => {
      sendToastStartDataLoadSuccess();
    },
    onError: (error) => {
      handleError([error]);
    },
  });

  useEffect(() => {
    console.log('useEffect activated');
    const currentTime = new Date();
    const dataLoadLastRunDate = new Date(dataLoadLastRun ?? '');
    const disabledMinutesAfterLastRun = new Date(dataLoadLastRunDate?.getTime() + DISABLED_IN_MINUTES * 60 * 1000);
    if (currentTime >= disabledMinutesAfterLastRun) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [dataLoadLastRun, isRefetching]);

  const handleClick = () => {
    trpcUtils.getDataLoadLastRun.invalidate();
    trpcUtils.getDataLoadLastRun.refetch();
    startDataLoad({ year: activeYear });
    setDisabledButton(true);
    window.location.reload(); //clumpsy implementation, this is to force a refetch of the last run date. Not sure why the trpcUtils didn't refetch the call.
  };
  return (
    <div className="ml-10 mt-10 flex flex-col items-center justify-center gap-10">
      <div>
        <p>{`Please note that the start data load button is disabled for ${DISABLED_IN_MINUTES} minutes after the last data load.`}</p>
        <p>This is to prevent multiple data loads from being triggered in a short period of time.</p>
      </div>
      <div>
        <Button
          variant="outline-secondary"
          className="h-10 border-black bg-black text-white hover:bg-transparent hover:text-black focus:outline-none focus-visible:ring-1
            focus-visible:ring-inset focus-visible:ring-white focus-visible:ring-offset-0"
          onClick={handleClick}
          disabled={disabledButton}
        >
          Start data load
        </Button>
      </div>
      <div className="flex flex-col gap-10">
        <RequirementsScroll />
        <TroubleshootingScroll />
        <ErdDiagram />
      </div>
    </div>
  );
};
